import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'saffron-button',
  templateUrl: './saffron-button.component.html',
  styleUrls: ['./saffron-button.component.scss']
})
export class SaffronButtonComponent implements OnInit {

  @Input() text: string = '';
  @Input() type: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'secondary-danger' = 'primary';
  @Input() size: 'small' | 'wide' | 'regular' = 'regular';
  @Input() width: string = '';
  @Input() height: string = '';
  @Input() is_loading: boolean = false;
  @Input() is_disabled: boolean = false;

  constructor() { }

  public getButtonClass() {
    const button_class_list = [];

    // Get button type
    button_class_list.push(`btn-${this.type}`);
    // Get button size
    button_class_list.push(`btn-${this.size}`);

    return button_class_list;
  }

  public getButtonStyle() {
    const style: { [key: string]: string } = {};
    if (this.width) {
      style['width'] = this.width;
    }
    if (this.height) {
      // set both CSS var for internal sizing and explicit height for layout
      style['--btn-height'] = this.height;
      style['height'] = this.height;
    }
    return style;
  }

  // Ensures that the loading icon is in the center of the button
  public getIconStyle() {
    // Positioning handled via CSS (centered with transform).
    // Keep function for backward compatibility with templates that might bind it.
    return {};
  }

  ngOnInit(): void {
  }

}
